module.exports = __webpack_public_path__ + "img/voice.1bd34f69.png";